import { paymentModeActionTypes } from '../../actions/configurations/paymentModeAction';

const PaymentModeReducers = (state = {}, action) => {
  switch (action.type) {
  case paymentModeActionTypes.GET_PAYMENT_MODES.LOADING: {
    const { getPaymentModeLoading } = action;
    return {
      ...state,
      getPaymentModeLoading,
    };
  }

  case paymentModeActionTypes.GET_PAYMENT_MODES.SUCCESS: {
    const { paymentModeResults } = action;
    return {
      ...state,
      paymentModeResults,
    };
  }

  case paymentModeActionTypes.UPDATE_PAYMENT_MODE.LOADING: {
    const { updatePaymentModeLoading } = action;
    return {
      ...state,
      updatePaymentModeLoading,
    };
  }

  case paymentModeActionTypes.CREATE_PAYMENT_MODE.LOADING: {
    const { createPaymentModeLoading } = action;
    return {
      ...state,
      createPaymentModeLoading,
    };
  }

  case paymentModeActionTypes.DELETE_PAYMENT_MODE.LOADING: {
    const { deletePaymentModeLoading } = action;
    return {
      ...state,
      deletePaymentModeLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default PaymentModeReducers;
